import React from 'react';
import { FontItem } from '../types';

interface FontSelectorProps {
  currentFont: FontItem;
  onOpenModal: () => void;
}

const FontSelector: React.FC<FontSelectorProps> = ({ currentFont, onOpenModal }) => {
  return (
    <div className="bg-white rounded-xl shadow-sm p-1 mb-1">
      <div className="flex justify-between items-center">
        <div>
          <span className="text-xs text-gray-500">当前字体</span>
          <div className="font-medium text-gray-800">{currentFont.name}</div>
        </div>
        <button
          onClick={onOpenModal}
          className="flex items-center text-[#3B82F6] text-sm"
        >
          选择字体 <i className="fa fa-chevron-right ml-1 text-xs"></i>
        </button>
      </div>
    </div>
  );
};

export default FontSelector;
